import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [servicesMenuOpen, setServicesMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`modern-header ${scrolled ? 'scrolled' : ''}`}>
      {/* Top Bar */}
      <div className="header-top-bar">
        <div className="header-top-content">
          <div className="header-top-left">
            <Link to="/contact">
              <svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor">
                <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"></path>
              </svg>
              Besoin d'un devis gratuit ? Contactez-nous
              <span className="header-top-sep" aria-hidden="true">•</span>
              <a className="header-top-phone" href="tel:+33769703585">(+33) 7 69 70 35 85</a>
            </Link>
          </div>
          <div className="header-top-right">
            <a href="https://www.facebook.com/profile.php?id=61574087001416" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
              <svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor">
                <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/call.garden.pro/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
              <svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor">
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </a>
            <a href="https://www.tiktok.com/@call_garden" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok">
              <svg width="16" height="16" viewBox="0 0 448 512" fill="currentColor">
                <path d="M448 209.91a210.06 210.06 0 0 1-122.77-39.25v178.72A162.55 162.55 0 1 1 185 188.31v89.89a74.62 74.62 0 1 0 52.23 71.18V0h88a121.18 121.18 0 0 0 1.86 22.17A122.18 122.18 0 0 0 448 209.91z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="header-main">
        <Link to="/" className="header-logo">
          <img src="/logo/logoheader.svg" alt="CallGarden" className="brand-logo brand-logo--header" />
        </Link>

        <nav>
          <ul className={`header-nav ${menuOpen ? 'open' : ''}`}>
            <li><Link to="/" className={isActive('/') ? 'active' : ''}>Accueil</Link></li>
            <li><Link to="/a-propos-de-nous" className={isActive('/a-propos-de-nous') ? 'active' : ''}>À propos de nous</Link></li>
            <li 
              className="dropdown-parent"
              onMouseEnter={() => setServicesMenuOpen(true)}
              onMouseLeave={() => setServicesMenuOpen(false)}
            >
              <Link to="/services" className={isActive('/services') ? 'active' : ''}>
                Services
                <svg width="12" height="12" viewBox="0 0 512 512" fill="currentColor" style={{display: 'block', flexShrink: 0, marginTop: '1px'}}>
                  <path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-143 143c-9.4 9.4-24.6 9.4-33.9 0L95 201c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l127.1 127z"></path>
                </svg>
              </Link>
              {servicesMenuOpen && (
                <ul className="dropdown-menu">
                  <li><Link to="/services/service-particulier">Service Particulier</Link></li>
                  <li><Link to="/services/service-entreprises">Service entreprises</Link></li>
                  <li><Link to="/nettoyage-terrasse-île-de-france">Nettoyage de terrasse</Link></li>
                  <li><Link to="/elagage-arbre-île-de-france">Élagage d'arbres</Link></li>
                  <li><Link to="/services/la-tonte">La Tonte</Link></li>
                  <li><Link to="/tailler-haies-evry-courcouronnes">Taille de haie</Link></li>
                  <li><Link to="/services/amenagement-paysager">Aménagement paysager</Link></li>
                  <li><Link to="/services/credit-dimpot-jardin">Crédit d'impôt jardin</Link></li>
                </ul>
              )}
            </li>
            <li><Link to="/contact" className={isActive('/contact') ? 'active' : ''}>Contact</Link></li>
          </ul>
        </nav>

        <button 
          className="mobile-menu-toggle" 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
    </header>
  );
};

export default Header;
